/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GPSPosition { 
    idData?: number;
    insertTs?: string;
    rawMessageId?: number;
    scts?: string;
    acquisitionTime?: string;
    idDevice?: number;
    idSensor?: number;
    originCode?: GPSPosition.OriginCodeEnum;
    dataUploadSource?: GPSPosition.DataUploadSourceEnum;
    extendedMessageType?: GPSPosition.ExtendedMessageTypeEnum;
    ecefX?: number;
    ecefY?: number;
    ecefZ?: number;
    latitude?: number;
    longitude?: number;
    altitude?: number;
    dop?: number;
    fixType?: GPSPosition.FixTypeEnum;
    positionError?: number;
    satCount?: number;
    ch01SatId?: number;
    ch01SatCnr?: number;
    ch02SatId?: number;
    ch02SatCnr?: number;
    ch03SatId?: number;
    ch03SatCnr?: number;
    ch04SatId?: number;
    ch04SatCnr?: number;
    ch05SatId?: number;
    ch05SatCnr?: number;
    ch06SatId?: number;
    ch06SatCnr?: number;
    ch07SatId?: number;
    ch07SatCnr?: number;
    ch08SatId?: number;
    ch08SatCnr?: number;
    ch09SatId?: number;
    ch09SatCnr?: number;
    ch10SatId?: number;
    ch10SatCnr?: number;
    ch11SatId?: number;
    ch11SatCnr?: number;
    ch12SatId?: number;
    ch12SatCnr?: number;
    mortalityStatus?: GPSPosition.MortalityStatusEnum;
    activity?: number;
    mainVoltage?: number;
    backupVoltage?: number;
    temperature?: number;
    lightCondition?: GPSPosition.LightConditionEnum;
    utmEasting?: number;
    utmNorthing?: number;
    utmZone?: number;
    utmLetter?: string;
    isValid?: boolean;
}
export namespace GPSPosition {
    export const OriginCodeEnum = {
        Globalstar: 'GLOBALSTAR',
        Iridium: 'IRIDIUM',
        GsmSms: 'GSM_SMS',
        GsmFtp: 'GSM_FTP',
        Terminal: 'TERMINAL',
        Collar: 'COLLAR',
        NbIot: 'NB_IOT',
        IridiumEmail: 'IRIDIUM_EMAIL'
    } as const;
    export type OriginCodeEnum = typeof OriginCodeEnum[keyof typeof OriginCodeEnum];
    export const DataUploadSourceEnum = {
        Provider: 'PROVIDER',
        Gdx: 'GDX',
        HttpUpload: 'HTTP_UPLOAD'
    } as const;
    export type DataUploadSourceEnum = typeof DataUploadSourceEnum[keyof typeof DataUploadSourceEnum];
    export const ExtendedMessageTypeEnum = {
        NoContact: 'NO_CONTACT',
        Mortality: 'MORTALITY',
        Status: 'STATUS',
        Null: 'NULL',
        Expelled: 'EXPELLED'
    } as const;
    export type ExtendedMessageTypeEnum = typeof ExtendedMessageTypeEnum[keyof typeof ExtendedMessageTypeEnum];
    export const FixTypeEnum = {
        NoFix: 'NO_FIX',
        OneGpsSat: 'ONE_GPS_SAT',
        TwoGpsSat: 'TWO_GPS_SAT',
        TwoDFix: 'TWO_D_FIX',
        ThreeDFixNotValidated: 'THREE_D_FIX_NOT_VALIDATED',
        ThreeDFixValidated: 'THREE_D_FIX_VALIDATED'
    } as const;
    export type FixTypeEnum = typeof FixTypeEnum[keyof typeof FixTypeEnum];
    export const MortalityStatusEnum = {
        NotAvailable: 'NOT_AVAILABLE',
        NothingDetected: 'NOTHING_DETECTED',
        LowActivityNoRadius: 'LOW_ACTIVITY_NO_RADIUS',
        LowActivityInsideRadius: 'LOW_ACTIVITY_INSIDE_RADIUS',
        LowActivityOutsideRadius: 'LOW_ACTIVITY_OUTSIDE_RADIUS',
        MortalityNoRadius: 'MORTALITY_NO_RADIUS',
        MortalityInsideRadius: 'MORTALITY_INSIDE_RADIUS',
        MortalityOutsideRadius: 'MORTALITY_OUTSIDE_RADIUS'
    } as const;
    export type MortalityStatusEnum = typeof MortalityStatusEnum[keyof typeof MortalityStatusEnum];
    export const LightConditionEnum = {
        Undefined: 'UNDEFINED',
        Bright: 'BRIGHT',
        Dark: 'DARK',
        Twilight: 'TWILIGHT',
        Unknown: 'UNKNOWN'
    } as const;
    export type LightConditionEnum = typeof LightConditionEnum[keyof typeof LightConditionEnum];
}


export type FixTypeEnum = typeof GPSPosition.FixTypeEnum[keyof typeof GPSPosition.FixTypeEnum];
export type MortalityStatusEnum = typeof GPSPosition.MortalityStatusEnum[keyof typeof GPSPosition.MortalityStatusEnum];
export type LightConditionEnum = typeof GPSPosition.LightConditionEnum[keyof typeof GPSPosition.LightConditionEnum];
